import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    alternative_names: [],
    alternative_names_translation: [],
    alternative_names_url: '/common/alternative-names',
    alternative_names_translation_url: '/common/alternative-names-translation',

}

const getters = {
    [names.ALTERNATIVE_NAMES]: state => {
        if (!get.store.state.user) return [];
        return state.alternative_names.filter((x) => x.school == get.store.state.user.school).sort((a, b) => a.id - b.id);
    },
    [names.ALTERNATIVE_NAMES_TRANSLATIONS]: state => {
        return state.alternative_names_translation.sort((a, b) => a.id - b.id);
    },
}

const mutations = {
    [names.MUTATE_ALTERNATIVE_NAMES]: (state, alternative_names) => {
        alternative_names.forEach(element => {
            let index = state.alternative_names.findIndex(x => x.id == element.id);
            if (index != -1) {
                state.alternative_names.splice(index, 1, element);
                localStorage.setItem("alternative_names", JSON.stringify(state.alternative_names));
            } else {
                state.alternative_names.push(element);
                localStorage.setItem("alternative_names", JSON.stringify(state.alternative_names));
            }
        });
    },
    [names.OVERRIDE_ALTERNATIVE_NAMES]: (state, alternative_names) => {
        alternative_names.forEach(element => {
            let index = state.alternative_names.findIndex(x => x.id == element.id);
            if (index != -1) {
                state.alternative_names.splice(index, 1, element);
            } else {
                state.alternative_names.push(element);
            }
        });
    },
    [names.MUTATE_ALTERNATIVE_NAME]: (state, alternative_name) => {
        let index = state.alternative_names.findIndex(x => x.id == alternative_name.id);
        if (index != -1) {
            state.alternative_names.splice(index, 1, alternative_name);
            localStorage.setItem("alternative_names", JSON.stringify(state.alternative_names));
        } else {
            state.alternative_names.push(alternative_name);
            localStorage.setItem("alternative_names", JSON.stringify(state.alternative_names));
        }
    },
    [names.MUTATE_DELETE_ALTERNATIVE_NAME]: (state, alternative_name_id) => {
        let index = state.alternative_names.findIndex(x => x.id == alternative_name_id);
        if (index != -1) {
            state.alternative_names.splice(index, 1);
            localStorage.setItem("alternative_names", JSON.stringify(state.alternative_names));
        }
    },
    [names.MUTATE_ALTERNATIVE_NAMES_TRANSLATIONS]: (state, alternative_names_translations) => {
        alternative_names_translations.forEach(element => {
            let index = state.alternative_names_translation.findIndex(x => x.id == element.id);
            if (index != -1) {
                state.alternative_names_translation.splice(index, 1, element);
            } else {
                state.alternative_names_translation.push(element);
            }
        });
    },
    [names.MUTATE_ALTERNATIVE_NAMES_TRANSLATION]: (state, alternative_names_translation) => {
        let index = state.alternative_names_translation.findIndex(x => x.id == alternative_names_translation.id);
        if (index != -1) {
            state.alternative_names_translation.splice(index, 1, alternative_names_translation);
        } else {
            state.alternative_names_translation.push(alternative_names_translation);
        }
    },
    [names.MUTATE_DELETE_ALTERNATIVE_NAMES_TRANSLATION]: (state, alternative_names_translation_id) => {
        let index = state.alternative_names_translation.findIndex(x => x.id == alternative_names_translation_id);
        if (index != -1) {
            state.alternative_names_translation.splice(index, 1);
        }
    },
}

const actions = {
    [names.FETCH_ALTERNATIVE_NAME]: ({
        commit,
        state
    }, alternative_name_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.alternative_names_url}/${alternative_name_id}/`)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAME, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_ALTERNATIVE_NAMES]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve) => {
            if (!force && state.alternative_names.length > 0) {
                resolve(state.alternative_names);
                return;
            }
            // Guard: en el boot de login este dispatch corre ANTES de que el fetch del
            // usuario resuelva — con cache presente (browser que ya se usó) el filtro por
            // school reventaba con user=null (los getters de este módulo ya tenían el
            // mismo guard; el branch de cache nunca lo recibió). Sin usuario se salta el
            // cache y se va a red: el backend igual scopea por school del lado servidor.
            const current_user = get.store.state.user;
            if (current_user && localStorage.getItem('alternative_names')) {
                let alternative_names = JSON.parse(localStorage.getItem('alternative_names'));
                if (alternative_names != null) {
                    alternative_names = alternative_names.filter((x) => x.school == current_user.school);
                    if (alternative_names.length > 0) {
                        commit(names.MUTATE_ALTERNATIVE_NAMES, alternative_names);
                        resolve(alternative_names);
                        return;
                    }
                }
            }
            restful.GetAll(`${state.alternative_names_url}/`)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES, response);
                    resolve(response);
                });
        });
    },
    [names.POST_ALTERNATIVE_NAME]: ({
        commit,
        state
    }, alternative_name) => {
        return new Promise((resolve) => {
            restful.Post(`${state.alternative_names_url}/`, alternative_name)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAME, response);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_ALTERNATIVE_NAME]: ({
        commit,
        state
    }, alternative_name) => {
        return new Promise((resolve) => {
            restful.Put(`${state.alternative_names_url}/${alternative_name.id}/`, alternative_name)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAME, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_ALTERNATIVE_NAME]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.alternative_names_url}/${payload.alternative_name_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAME, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_ALTERNATIVE_NAME]: ({
        commit,
        state
    }, alternative_name_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.alternative_names_url}/${alternative_name_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_ALTERNATIVE_NAME, alternative_name_id);
                    resolve(response);
                });
        });
    },
    [names.FETCH_ALTERNATIVE_NAMES_TRANSLATION]: ({
        commit,
        state
    }, alternative_names_translation_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.alternative_names_translation_url}/${alternative_names_translation_id}/`)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES_TRANSLATION, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_ALTERNATIVE_NAMES_TRANSLATIONS]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve) => {
            if (!force && state.alternative_names_translation.length > 0) {
                resolve(state.alternative_names_translation);
                return;
            }
            restful.GetAll(`${state.alternative_names_translation_url}/`)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES_TRANSLATIONS, response);
                    resolve(response);
                });
        });
    },
    [names.POST_ALTERNATIVE_NAMES_TRANSLATION]: ({
        commit,
        dispatch,
        state
    }, alternative_names_translation) => {
        return new Promise((resolve) => {
            restful.Post(`${state.alternative_names_translation_url}/`, alternative_names_translation)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES_TRANSLATION, response);
                    dispatch(names.FETCH_ALTERNATIVE_NAME, response.alternative_name);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_ALTERNATIVE_NAMES_TRANSLATION]: ({
        commit,
        dispatch,
        state
    }, alternative_names_translation) => {
        return new Promise((resolve) => {
            restful.Put(`${state.alternative_names_translation_url}/${alternative_names_translation.id}/`, alternative_names_translation)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES_TRANSLATION, response);
                    dispatch(names.FETCH_ALTERNATIVE_NAME, response.alternative_name);
                    resolve(response);
                });
        });
    },
    [names.PATCH_ALTERNATIVE_NAMES_TRANSLATION]: ({
        commit,
        dispatch,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.alternative_names_translation_url}/${payload.alternative_names_translation_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_ALTERNATIVE_NAMES_TRANSLATION, response);
                    dispatch(names.FETCH_ALTERNATIVE_NAME, response.alternative_name);
                    resolve(response);
                });
        });
    },
    [names.DELETE_ALTERNATIVE_NAMES_TRANSLATION]: ({
        commit,
        dispatch,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.alternative_names_translation_url}/${payload.alternative_names_translation_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_ALTERNATIVE_NAMES_TRANSLATION, payload.alternative_names_translation_id);
                    dispatch(names.FETCH_ALTERNATIVE_NAME, payload.alternative_name_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};